export enum CountryCodes {
  Canada = 'CA',
  USA = 'US',
}

type CountryOption = {
  label: 'Canada' | 'USA';
  value: CountryCodes;
};

export const countryOptions: CountryOption[] = [
  { label: 'USA', value: CountryCodes.USA },
  { label: 'Canada', value: CountryCodes.Canada },
];
